<script>
export default {
  name: "DidoApidocUsageResources",
};
</script>

<template>
  <div class="q-mt-md line-height-15">
    Chaque ressource est accessible via ses identifiants.
    <br />
    Voici la liste des identifiants en fonction de chaque type :
    <ul>
      <li>
        jeu de données : identifiant {datasetId}
        <br />
        =>
        <span class="text-italic">url pour récupérer un jeu de données </span>
        :
        <span class="bg-black text-white q-pa-xs"
          >$BASE_URL_API/datasets/{datasetId}</span
        >
      </li>
      <li>
        fichier de données : identifiant {datafileRid}
        <br />
        =>
        <span class="text-italic"
          >url pour récupérer le dernier millésime d'un fichier de données
        </span>
        :
        <span class="bg-black text-white q-pa-xs"
          >$BASE_URL_API/datafiles/{datafileRid}</span
        >
      </li>
      <li>
        millésime spécifique d'un fichier de données : identifiant {datafileRid}
        et valeur du millésime {millesimeValue}
        <br />
        =>
        <span class="text-italic"
          >url pour récupérer un millésime spécifique
        </span>
        :
        <span class="bg-black text-white q-pa-xs"
          >$BASE_URL_API/datafiles/{datafileRid}&millesime={millesileValue}</span
        >
      </li>
    </ul>
  </div>
</template>
